import { post } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import {
    getInstructionCards,
    setInstructionCards,
} from '~shared/utils/user';

import {
    ZERO,
    DISMISS_URL,
} from '../constants/constants';

/**
 * External function to remove instruction card when dismissed
 * Imported to dismiss button for clicking and also to carousel as swiping is used to dismiss
 * @param {string} type type of instruction card
 * @return {Array} updated instructionCards array
 */
export async function removeInstructionCard(type) {
    let instructionCards = getInstructionCards();

    if (instructionCards.indexOf(type) >= ZERO) {
        const INSTRUCTION_CARD_DISMISS = `${DISMISS_URL}${type}`;
        const url = buildSpectateUrl(INSTRUCTION_CARD_DISMISS);
        const response = await post(url);

        if (response.ok) {
            instructionCards = instructionCards.filter((card) => card !== type);
            setInstructionCards(instructionCards);

            return instructionCards;
        }
    }

    return instructionCards;
}
